const getters = {
  token: state => state.module.token,
  roles: state => state.module.roles,
  headShow: state => state.module.headShow,
  loading: state => state.module.loading,
  footerShow: state => state.module.footerShow,
  phoneShow: state => state.module.phoneShow,
  cooperShow: state => state.module.cooperShow,
  feedbackShow: state => state.module.feedbackShow,
  activityData:state=>state.module.activityData,
  pageTitle: state => state.module.pageTitle,
  addRouters: state => state.permission.addRouters,
  siderbar_routers:state => state.permission.siderbar_routers,
  permission_routers: state => state.permission.routers,
  openId: state => state.module.openId,

};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js